import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../lib/domain';
import { ApiError } from '../lib/api';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState<'pending' | 'ok' | 'error'>('pending');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Kein Bestätigungstoken gefunden.');
      return;
    }
    authApi
      .verifyEmail(token)
      .then(() => setStatus('ok'))
      .catch((err) => {
        setStatus('error');
        setMessage(err instanceof ApiError ? err.message : 'Bestätigung fehlgeschlagen.');
      });
  }, [token]);

  return (
    <div className="card stack">
      <h1>E-Mail-Bestätigung</h1>
      {status === 'pending' && <p>Bestätige…</p>}
      {status === 'ok' && <p>Deine E-Mail-Adresse wurde bestätigt. Du kannst dich jetzt anmelden.</p>}
      {status === 'error' && <p className="error-text">{message}</p>}
      <Link to="/login">Zur Anmeldung</Link>
    </div>
  );
}
